import {Layers, WalkOfShameLayers} from "./WalkOfShameLayers";
import {WalkOfShameGameAssets} from "../WalkOfShameGameAssets";
import {TimelineLite} from "gsap";
import {WalkOfShame} from "../WalkOfShame";
import {WalkOfShameGameMode} from "../server/WalkOfShameGameMode";
import {WalkOfShameHelper} from "../../core/utils/WalkOfShameHelper";

export class WalkOfShameMultiplier extends PIXI.Container {
    private _holder: PIXI.Sprite;
    private _holderFSTexture: PIXI.Texture;
    private _holderSFSTexture: PIXI.Texture;
    private _multiplier: PIXI.BitmapText;
    private _landingAnimation: PIXI.spine.Spine;

    constructor() {
        super();

        WalkOfShameLayers.getLayer(Layers.MULTIPLIER)?.addChild(this);
        this.init();
    }

    private _multiValue: number = 1;

    get multiValue(): number {
        return this._multiValue;
    }

    public toggleMultiplier(visible: boolean): void {
        this._multiplier.visible = visible;
        this._holder.visible = visible;
    }

    public updateMultiplierText(val: number, canAnimate: boolean): TimelineLite {
        const tl: TimelineLite = new TimelineLite();

        if (canAnimate) {
            const animName: string = (WalkOfShame.model.parsedGameData.mode === WalkOfShameGameMode.FREESPIN ? "FS" : "SFS");

            tl.add([
                () => {
                    this._landingAnimation.visible = true;
                    this._landingAnimation.updateTransform();

                    this._landingAnimation.state.clearTracks();
                    this._landingAnimation.state.setEmptyAnimation(0, 0);
                },
                WalkOfShameHelper.createTimelineForAnimation(this._landingAnimation, 0, animName, false)
            ]);

            tl.add(() => {
                this.setText(val);
            }, 0.2);

            tl.add(() => {
                this._landingAnimation.visible = false;
                this._landingAnimation.state.clearTracks();
            });
        } else {
            this.setText(val);
        }

        return tl;
    }

    public onModeChange(mode: string): void {
        if (mode === WalkOfShameGameMode.SUPER_FREESPIN || mode === WalkOfShameGameMode.SUPER_FREESPIN_RESPIN) {
            this._holder.texture = this._holderSFSTexture;
            this._holder.x = 3;
        } else if (mode === WalkOfShameGameMode.FREESPIN) {
            this._holder.texture = this._holderFSTexture;
            this._holder.x = 0;
        }
    }

    private init(): void {
        this.position.set(65, 94);

        this._holderFSTexture = WalkOfShame.assetLoader.getTextures("multipliers/multiplier_FS")[0];
        this._holderSFSTexture = WalkOfShame.assetLoader.getTextures("multipliers/multiplier_SFS")[0];

        this._holder = new PIXI.Sprite();
        this._holder.visible = false;
        this._holder.anchor.set(0.5);

        this._multiplier = new PIXI.BitmapText("X1", {
            fontName: WalkOfShameGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 28,
            tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
        this._multiplier.visible = false;
        this._multiplier.anchor = new PIXI.Point(0.5, 0);
        this._multiplier.position.set(3, -this._multiplier.height / 2);

        this._landingAnimation = new PIXI.spine.Spine(WalkOfShame.assetLoader.getSpineAsset("multiplierLanding"));
        this._landingAnimation.visible = false;

        this.addChild(this._holder, this._multiplier, this._landingAnimation);
    }

    private setText(val: number): void {
        this._multiValue = val;

        this._multiplier.fontSize = 28;
        this._multiplier.text = "X" + val;
        while (this._multiplier.textWidth > 90) {
            this._multiplier.fontSize--;
            this._multiplier.dirty = true;
            this._multiplier.updateTransform();
        }
        this._multiplier.y = -this._multiplier.height / 2;
    }
}